import React from 'react';

const Map = () => {
  return (
    <div style={{ width: '100%', height: '450px', marginBottom: '-6px' }}>
      <iframe
        title="Google Map"
        src="https://www.google.com/maps?q=4-579+Kerr+Street,+Oakville,+Ontario,+Canada+L6K+3E1&output=embed"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Map;